import 'core-js/stable';
import 'regenerator-runtime/runtime';
import HashPopupWhitelists from '../constants/HashPopupWhitelists';
import PopupOpenConfigStorage from '../constants/PopupOpenConfigStorage';
// @ts-ignore
import './modules/registration_popup/registrationV3';
import './modules/registration_popup/registarionV3WithSubscription';
import './modules/registration_popup/registarionWithPollAb';
import './modules/popupFunctions';
import './modules/jsForm';
import 'lightslider';
import 'cloud9carousel';
import { PopupIds } from '../constants/PopupIds';
import { StretchPopup } from '../popups/stretchPopup';
import { PopupManager } from '../popups/popupManager';
import { onReadyCalcBack } from './calcIndexBackAndPopup';
import { startupConfigureCommonUnauth } from '../startup/configure';
import { exposeLoginHandlerFunctions } from '../login/common';
import { initFbSdk } from '../login/fb';
import { setupPassStrengthWidgetListener } from '../view/password-strength-widget';
import { CurrentEntryPoint } from '../constants/CurrentEntryPoint';
import { GoogleOneTap } from '../login/google/google-one-tap';
import { Environment } from '../environment/environment';
import { MobileLpFormHandlers } from './modules/registration_popup/MobileLpFormHandler';
import { initAppleId } from '../login/apple_id';
import { initLoginHandlers } from '../login/loginHandlers';
import { initLoginFailFunction } from '../login/triumphClosure';
import { initRegistrationWithOtpForm } from './modules/registration_popup/registrationWithOtp';
import { getGoogleSignIn } from '../login/google/get-google-sign-in';

startupConfigureCommonUnauth();
$(onDocumentReady);

function openPopupFromLocationHash(): void {
    let popupId: PopupIds;
    const whitelist = HashPopupWhitelists.SITE_INDEX;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    popupId = window.location.hash.slice(1).split('?') as any;
    popupId = popupId[0] as PopupIds;

    if (whitelist.indexOf(popupId) !== -1) {
        window.app.closePopups();
        window.app.popup(PopupOpenConfigStorage.getPopupOpenConfig(popupId));
        PopupManager.openSingle(popupId);
    }
}

function setupListeners(): void {
    $('.popup .js-close-button').on('click', function handlePopupJsCloseClick() {
        window.app.closePopups();
        PopupManager.openSingle(PopupIds.REGISTRATION);
    });
    $('.popup2 .js-close-button').on('click', function handlePopup2JsCloseClick() {
        window.app.closePopups({ hideclass: 'popup2' });
    });
    $('.js-toggle-checked').on('click', function handleJsToggleChecked() {
        $(this).toggleClass('checked');
    });

    $('[data-go-top]').on('click', scrollTop);


    setupPassStrengthWidgetListener();
}

function onDocumentReady() {
    PopupManager.init();
    StretchPopup.stretch();
    $(window).on('resize', () => {
        StretchPopup.stretch();
    });

    initLoginHandlers();

    if (window.location.hash) {
        openPopupFromLocationHash();
    }
    setupListeners();
    exposeLoginHandlerFunctions();
    initLoginMethods();
    initSeoIndexCarousels();
    initLoginFailFunction();
    initRegistrationWithOtpForm();
    onReadyCalcBack();
    $('video').on('load loadedmetadata', () => {
        onReadyCalcBack();
    });

    if (Environment.isLanding()) {
        initLpHandlers();
    }
}

function initLoginMethods() {
    initFbSdk();
    if (!window.app.isSite1) {
        initAppleId();
    }
    getGoogleSignIn().init();
    if (isItAllowedForGoogleOneTap()) {
        const googleIneTap = new GoogleOneTap(window.app.config.google);
        googleIneTap.init();
    }
}
function isItAllowedForGoogleOneTap(): boolean {
    if ((!window.app.config.landings.enableGoogleOneTap && Environment.isLanding())) {
        return false;
    }

    if (![CurrentEntryPoint.SITE, CurrentEntryPoint.SITE2].includes(window.app.config.current_entry_point)) {
        return false;
    }

    return true;
}

function scrollTop() {
    $(document).scrollTop(0);
}


function initSeoIndexCarousels() {
    // @ts-ignore
    $('#carousel').Cloud9Carousel({
        buttonLeft: $('.navigate-right'),
        buttonRight: $('.navigate-left'),
        frontItemClass: 'active',
        itemClass: 'slide',
        yOrigin: 0,
        yRadius: -24
    });

    // @ts-ignore
    $('.seo-index-layout__feedback').lightSlider({
        adaptiveHeight: window.app.isMobile,
        item: 1,
        nextHtml: '<div class=\'seo-index-layout__navigate-right\'></div>',
        prevHtml: '<div class=\'seo-index-layout__navigate-left\'></div>'
    });
}

function initLpHandlers(): void {
    const mobileLpHandlers = new MobileLpFormHandlers(window.app.config);
    mobileLpHandlers.registerHandlers();
}


